<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card title="用户信息">
        <div class="flex xs12 sm12">
          <div class="d-flex justify--end">
            <va-button color="info" v-show="showSetMenteeAccount" @click="setToMenteeAccount($route.params.uid)">
              设置为学员类型
            </va-button>
            <va-button
              color="danger"
              v-show="!showSetMenteeAccount"
              @click="confirmTerminateService($route.params.uid)">
              终止服务
            </va-button>
            <va-button
              outline
              color="primary"
              @click="$router.push({ name: 'listJobUser', query: {inviterUid: $route.params.uid}})">
              邀请记录
            </va-button>
          </div>
        </div>
        <div class="row">
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="basicInfo.nickname"
              label="姓名"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              label="用户邮箱"
              v-model="basicInfo.email"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              label="注册时间"
              v-model="basicInfo.createTime"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              label="个人邀请链接"
              v-model="basicInfo.inviteLink"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              label="免费用户邀请人数"
              v-model="basicInfo.inviteFreeNum"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              label="basic付费用户邀请人数"
              v-model="basicInfo.inviteBasicNum"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              label="pro付费用户邀请人数"
              v-model="basicInfo.inviteProNum"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              label="邀请人姓名"
              v-model="basicInfo.inviterNickname"
              disabled
            />
          </div>
        </div>
      </va-card>
    </div>
    <div class="flex xs10 offset--xs1" v-if="subscriptionShow">
      <va-card title="订阅信息（列表）">
        <va-data-table
          :fields="subscriptionFields"
          :data="pagedSubscriptionList"
          api-mode
        >
          <template slot="period" slot-scope="props">
            {{ formatPeriodTime(props.rowData.periodStartTime, props.rowData.periodEndTime) }}
          </template>
          <template slot="orderStatus" slot-scope="props">
            {{ computeOrderStatus(props.rowData.orderStatus, props.rowData.renewStatus, props.rowData.payTimes) }}
          </template>
          <template slot="cancelInfo" slot-scope="props">
            <div v-if="props.rowData.cancelTime || props.rowData.cancelReason || props.rowData.feedback" class="text-sm leading-snug">
              <div v-if="props.rowData.cancelTime"><strong>时间：</strong>{{ formatTime(props.rowData.cancelTime) }}</div>
              <div v-if="props.rowData.cancelReason"><strong>原因：</strong>{{ props.rowData.cancelReason }}</div>
              <div>
                <strong>反馈：</strong>{{ props.rowData.feedback || '无' }}
              </div>
            </div>
          </template>

        </va-data-table>

        <div class="d-flex align--center justify--center mt-2" v-if="subscriptionTotalPages > 1">
          <va-button flat small icon="fa fa-chevron-left" :disabled="subscriptionPage <= 1" @click="subscriptionPage--"/>
          <span class="mx-2">第 {{ subscriptionPage }} / {{ subscriptionTotalPages }} 页（共 {{ subscriptionList.length }} 条）</span>
          <va-button flat small icon="fa fa-chevron-right" :disabled="subscriptionPage >= subscriptionTotalPages" @click="subscriptionPage++"/>
        </div>
      </va-card>
    </div>

    <div class="flex xs10 offset--xs1" v-if="surveyShow">
      <va-card title="问卷信息">
        <div class="flex xs12 sm12">
          <div class="d-flex justify--end">
            <va-button color="info" @click="deleteJobSurvey($route.params.uid)">删除问卷</va-button>
          </div>
        </div>
        <div class="row">
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="jobSurvey.name"
              label="姓名"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              label="邮箱"
              v-model="jobSurvey.email"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              label="地区"
              v-model="jobSurvey.region"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              label="岗位类型"
              v-model="employmentType"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              label="年限"
              v-model="careerStage"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              label="work areas"
              v-model="jobSurvey.workAreas"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              label="concerns"
              v-model="jobSurvey.concerns"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              label="assistanceAreas"
              v-model="jobSurvey.assistanceAreas"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              label="source"
              v-model="source"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              label="recommend"
              v-model="isRecommend"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              label="suggestions"
              v-model="jobSurvey.suggestions"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              label="推送周期"
              v-model="noticeFrequency"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              label="简历链接"
              v-model="jobSurvey.resumeUrl"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              label="是否远程"
              v-model="jobSurvey.remotePreference"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              label="Sponsorship"
              v-model="visaSponsorship"
              disabled
            />
          </div>
        </div>
      </va-card>
    </div>
    <div class="flex xs10 offset--xs1" v-if="pushRecordShow">
      <va-card title="岗位推送记录">
        <div class="row align--center mb-1">
        </div>
        <va-data-table
          :fields="fields"
          :data="pagedJobPushRecord"
          api-mode
        >
        </va-data-table>

        <div class="d-flex align--center justify--center mt-2" v-if="jobPushTotalPages > 1">
          <va-button flat small icon="fa fa-chevron-left" :disabled="jobPushPage <= 1" @click="jobPushPage--"/>
          <span class="mx-2">第 {{ jobPushPage }} / {{ jobPushTotalPages }} 页（共 {{ jobPushRecord.length }} 条）</span>
          <va-button flat small icon="fa fa-chevron-right" :disabled="jobPushPage >= jobPushTotalPages" @click="jobPushPage++"/>
        </div>
      </va-card>
    </div>

    <div class="flex xs10 offset--xs1" v-if="autoApplyLoaded">
      <va-card title="自动代投">
        <div v-if="!autoApply.hasProfile" class="pa-3">
          <p>该用户尚未创建代投 Profile（job_apply_profile）。</p>
        </div>
        <div v-else>
          <!-- 概览：周期已用 / 限额 / 累计成功 -->
          <div class="row mb-2">
            <div class="flex md4 sm6 xs12">
              <va-input
                :value="quotaProgressText"
                label="当前周期已用 / 限额"
                disabled
              />
            </div>
            <div class="flex md4 sm6 xs12">
              <va-input
                :value="autoApplyPeriodText"
                label="周期范围"
                disabled
              />
            </div>
            <div class="flex md4 sm6 xs12">
              <va-input
                :value="String(autoApply.totalSuccess || 0)"
                label="历史累计成功投递"
                disabled
              />
            </div>
          </div>

          <div class="mb-3 pa-3 email-forward-panel">
            <div class="row align--center">
              <div class="flex md4 sm6 xs12">
                <va-checkbox
                  :value="emailForwardEnabled"
                  :label="emailForwardEnabled ? '私人邮箱转发：已开启' : '私人邮箱转发：未开启'"
                  :disabled="emailForwardToggleDisabled"
                  @input="confirmEmailForwardChange"
                />
              </div>
              <div class="flex md8 sm6 xs12">
                <span>{{ emailForwardStatusText }}</span>
              </div>
            </div>
            <div class="mt-1 text-danger" v-if="emailForwardErrorText">
              {{ emailForwardErrorText }}
            </div>
          </div>

          <!-- 按 ATS 站点维度的统计 -->
          <div class="mb-2">
            <h6>按 ATS 站点统计</h6>
            <va-data-table
              :fields="siteStatFields"
              :data="autoApply.siteStats || []"
              api-mode
            />
          </div>

          <!-- Profile 全字段铺开 -->
          <div class="mt-3">
            <h6>代投 Profile</h6>
            <div class="row">
              <div class="flex md4 sm6 xs12" v-for="f in profileFields" :key="f.key">
                <va-input
                  :value="formatProfileValue(autoApply.profile, f.key)"
                  :label="f.label"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import { copyObject, formatTime } from '@/utils/common'
import openJobApi from '@/api/openJob'

export default {
  data () {
    return {
      surveyShow: false,
      subscriptionShow: false,
      pushRecordShow: false,
      basicInfo: {
        uid: '',
        nickname: '',
        email: '',
        createTime: 0,
        startTime: 0,
        endTime: 0,
        type: 0,
        inviteLink: '',
        inviteFreeNum: 0,
        inviteBasicNum: 0,
        inviteProNum: 0,
        inviterUid: '',
        inviterNickname: '',
      },
      jobSurvey: {
        surveyId: '',
        uid: '',
        name: '',
        email: '',
        region: '',
        employmentType: 0,
        careerStage: 0,
        workAreas: '',
        concerns: '',
        assistanceAreas: '',
        source: 0,
        recommend: 0,
        resumeUrl: '',
        suggestions: '',
        resumeName: '',
        noticeFrequency: 0,
        remotePreference: '',
        visaSponsorship: 0,
      },
      subscriptionList: [],
      subscriptionPage: 1,
      subscriptionPageSize: 10,
      jobPushRecord: [],
      jobPushPage: 1,
      jobPushPageSize: 10,
      message: ['可以更改'],
      autoApplyLoaded: false,
      emailForwardLoading: false,
      autoApply: {
        hasProfile: false,
        profile: null,
        quotaUsed: 0,
        quotaLimit: 0,
        userType: null,
        periodStartTime: null,
        periodEndTime: null,
        totalSuccess: 0,
        siteStats: [],
      },
    }
  },
  created () {
    this.getUser()
    this.loadAutoApply()
  },
  computed: {
    sceneTextMap () {
      return {
        '-1': '未知场景',
        0: '唤醒邮件A(注册欢迎)',
        1: '唤醒邮件A(定时任务)',
        2: '唤醒邮件B(问卷欢迎)',
        3: '唤醒邮件B(定时任务)',
        4: '订阅每日',
        5: '订阅每周',
        6: '订阅首次推送',
      }
    },
    showSetMenteeAccount () {
      return this.basicInfo.type === 0 || this.basicInfo.type === -1
    },
    formReady () {
      return true
    },
    isRecommend () {
      const recommend = this.jobSurvey.recommend
      if (recommend === 1) {
        return 'Yes, I would recommend.'
      } else if (recommend === 0) {
        return 'No, I would not recommend.'
      } else {
        return 'Not sure.'
      }
    },
    source () {
      const source = this.jobSurvey.source
      if (source === 1) {
        return 'Shared from friends directly'
      } else if (source === 2) {
        return 'Get from Linkedin'
      } else if (source === 3) {
        return 'Get from Wechat'
      } else if (source === 4) {
        return 'Little Red Book(小红书)'
      } else if (source === 5) {
        return 'Twitter'
      } else if (source === 6) {
        return 'Tiktok'
      } else if (source === 7) {
        return 'Facebook/Ins'
      } else {
        return ''
      }
    },
    careerStage () {
      const careerStage = this.jobSurvey.careerStage

      if (careerStage.includes(',')) {
        const stages = careerStage.split(',').map(Number).sort((a, b) => a - b)
        return stages.map(stage => {
          if (stage === 1) {
            return 'Early Career (0-2 years)'
          } else if (stage === 2) {
            return 'Mid-Career (3-5 years)'
          } else if (stage === 3) {
            return 'Senior Career (6 years and above)'
          } else if (stage === 4) {
            return 'Seasoned Professional (10 years and above)'
          } else {
            return ''
          }
        }).join(', ')
      } else {
        const stage = Number(careerStage)
        if (stage === 1) {
          return 'Early Career (0-2 years)'
        } else if (stage === 2) {
          return 'Mid-Career (3-5 years)'
        } else if (stage === 3) {
          return 'Senior Career (6 years and above)'
        } else if (stage === 4) {
          return 'Seasoned Professional (10 years and above)'
        } else {
          return ''
        }
      }
    },
    employmentType () {
      const employmentType = this.jobSurvey.employmentType
      if (employmentType === 1) {
        return 'Internship'
      } else if (employmentType === 2) {
        return 'Full-Time Employment'
      } else {
        return 'Both'
      }
    },
    noticeFrequency () {
      const noticeFrequency = this.jobSurvey.noticeFrequency
      if (noticeFrequency === 1) {
        return 'weekly'
      } else if (noticeFrequency === 2) {
        return 'daily'
      } else {
        return 'weekly'
      }
    },
    visaSponsorship () {
      const visaSponsorship = this.jobSurvey.visaSponsorship
      if (visaSponsorship === 0) {
        return '不需要'
      } else if (visaSponsorship === 1) {
        return '需要'
      } else {
        return '都可以'
      }
    },
    subscriptionFields () {
      return [
        {
          name: 'orderId',
          title: '订单号',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '15%',
        },
        {
          name: 'totalAmount',
          title: '订阅金额($)',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '5%',
          callback: (val) => val / 100,
        },
        {
          name: 'originalStartTime',
          title: '订阅首期开始时间',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: '__slot:period',
          title: '当前周期',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '20%',
        },
        {
          name: 'payTimes',
          title: '支付次数',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '5%',
        },
        {
          name: '__slot:orderStatus',
          title: '订阅状态',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '15%',
        },
        {
          name: 'updateTime',
          title: '更新时间',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '15%',
        },
        {
          name: '__slot:cancelInfo',
          title: '取消信息',
          titleClass: 'text-center',
          dataClass: 'text-left',
          width: '20%',
        },
      ]
    },
    subscriptionTotalPages () {
      const total = this.subscriptionList ? this.subscriptionList.length : 0
      return Math.max(1, Math.ceil(total / this.subscriptionPageSize))
    },
    pagedSubscriptionList () {
      const start = (this.subscriptionPage - 1) * this.subscriptionPageSize
      return (this.subscriptionList || []).slice(start, start + this.subscriptionPageSize)
    },
    jobPushTotalPages () {
      const total = this.jobPushRecord ? this.jobPushRecord.length : 0
      return Math.max(1, Math.ceil(total / this.jobPushPageSize))
    },
    pagedJobPushRecord () {
      const start = (this.jobPushPage - 1) * this.jobPushPageSize
      return (this.jobPushRecord || []).slice(start, start + this.jobPushPageSize)
    },
    siteStatFields () {
      return [
        { name: 'site', title: '站点', titleClass: 'text-center', dataClass: 'text-center', width: '20%' },
        { name: 'total', title: '总数', titleClass: 'text-center', dataClass: 'text-center', width: '12%' },
        { name: 'success', title: '成功', titleClass: 'text-center', dataClass: 'text-center', width: '12%' },
        { name: 'processing', title: '投递中', titleClass: 'text-center', dataClass: 'text-center', width: '12%' },
        { name: 'failed', title: '失败', titleClass: 'text-center', dataClass: 'text-center', width: '12%' },
        { name: 'retryExhausted', title: '重试耗尽', titleClass: 'text-center', dataClass: 'text-center', width: '15%' },
        { name: 'welcome', title: 'Welcome 初投', titleClass: 'text-center', dataClass: 'text-center', width: '17%' },
      ]
    },
    /** 代投 Profile 全字段铺开。顺序按"联系/地址 → 链接 → 工作偏好 → 授权 → 平等机会信息" 分组排列。 */
    profileFields () {
      return [
        { key: 'firstName', label: 'First Name' },
        { key: 'lastName', label: 'Last Name' },
        { key: 'personalEmail', label: '个人邮箱' },
        { key: 'applyEmail', label: '代投邮箱' },
        { key: 'applyEmailPassword', label: '代投邮箱密码' },
        { key: 'phone', label: '电话' },
        { key: 'phoneCountryCode', label: '国家区号' },
        { key: 'country', label: '国家' },
        { key: 'state', label: '州/省' },
        { key: 'city', label: '城市' },
        { key: 'street', label: '街道' },
        { key: 'zipCode', label: '邮编' },
        { key: 'linkedin', label: 'LinkedIn' },
        { key: 'githubUrl', label: 'GitHub' },
        { key: 'portfolioUrl', label: 'Portfolio' },
        { key: 'expectedSalary', label: '期望薪资' },
        { key: 'noticePeriod', label: '入职通知期' },
        { key: 'yearsOfExperience', label: '工作年限' },
        { key: 'willingToRelocate', label: '愿意搬迁' },
        { key: 'workAuthorization', label: '签证状态' },
        { key: 'authorizedToWork', label: '是否合法工作授权' },
        { key: 'requireSponsorship', label: '是否需要签证担保' },
        { key: 'gender', label: '性别' },
        { key: 'raceEthnicity', label: '族裔' },
        { key: 'hispanicLatino', label: '是否拉丁裔' },
        { key: 'sexualOrientation', label: '性取向' },
        { key: 'lgbtq', label: 'LGBTQ' },
        { key: 'disabilityStatus', label: '残疾状态' },
        { key: 'veteranStatus', label: '退伍军人' },
        { key: 'matchThreshold', label: '匹配分数阈值' },
      ]
    },
    quotaProgressText () {
      const used = this.autoApply.quotaUsed || 0
      const limit = this.autoApply.quotaLimit || 0
      if (limit === 0) {
        return `${used} / 0（当前用户类型不参与代投）`
      }
      return `${used} / ${limit}`
    },
    autoApplyPeriodText () {
      const s = this.autoApply.periodStartTime
      const e = this.autoApply.periodEndTime
      if (!s || !e) {
        return '-'
      }
      return formatTime(s) + ' ~ ' + formatTime(e)
    },
    emailForwardEnabled () {
      return !!(this.autoApply.profile && Number(this.autoApply.profile.emailForwardEnabled) === 1)
    },
    emailForwardToggleDisabled () {
      if (this.emailForwardLoading || !this.autoApply.profile) return true
      if (this.emailForwardEnabled) return false
      return !this.autoApply.profile.applyEmail || !this.autoApply.profile.personalEmail
    },
    emailForwardStatusText () {
      const profile = this.autoApply.profile
      if (!profile) return ''
      const status = Number(profile.emailForwardSyncStatus || 0)
      if (status === 1) return '正在同步 Mailcow，请稍后重试或刷新页面'
      if (status === 2) return '最近一次 Mailcow 同步失败，可再次切换重试'
      if (this.emailForwardEnabled) {
        return `收件人邮件将同时转发至 ${profile.emailForwardTarget || profile.personalEmail}`
      }
      return `开启后将转发至 ${profile.personalEmail || '（个人邮箱未填写）'}`
    },
    emailForwardErrorText () {
      const profile = this.autoApply.profile
      if (!profile || Number(profile.emailForwardSyncStatus || 0) !== 2) return ''
      return profile.emailForwardError ? `失败原因：${profile.emailForwardError}` : '失败原因：未知错误'
    },
    fields () {
      return [
        {
          name: 'dayTime',
          title: '岗位推送日期',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: 'createTime',
          title: '创建时间',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: 'updateTime',
          title: '更新时间',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: 'count',
          title: '岗位推送数量',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '5%',
        },
        {
          name: 'sendStatus',
          title: '邮件发送结果',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: 'sceneText',
          title: '推送场景',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '15%',
        },
        {
          name: 'failReason',
          title: '失败原因',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '15%',
        },
        {
          name: 'matchResult',
          title: '技术指标',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '15%',
        },
        {
          name: 'openCount',
          title: '打开次数',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '5%',
        },
        {
          name: 'clickCount',
          title: '点击次数',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '5%',
        },
      ]
    },
  },
  methods: {
    formatTime,
    getUser () {
      const params = this.$route.params
      if (params.uid != null) {
        const data = {
          uid: params.uid,
        }
        // 通过id获取详情
        openJobApi.getUser(data).then(response => {
          copyObject(response.basicInfo, this.basicInfo)
          this.basicInfo.createTime = formatTime(this.basicInfo.createTime)
          // eslint-disable-next-line no-prototype-builtins
          if (response.hasOwnProperty('jobSurvey')) {
            copyObject(response.jobSurvey, this.jobSurvey)
            this.surveyShow = true
          }
          // eslint-disable-next-line no-prototype-builtins
          if (response.hasOwnProperty('subscriptionList')) {
            response.subscriptionList.forEach(item => {
              item.originalStartTime = formatTime(item.originalStartTime)
              item.updateTime = formatTime(item.updateTime)
            })
            this.subscriptionList = response.subscriptionList
            this.subscriptionShow = true
          }
          // eslint-disable-next-line no-prototype-builtins
          if (response.hasOwnProperty('jobPushList')) {
            response.jobPushList.forEach(item => {
              if (item.createTime) {
                item.createTime = formatTime(item.createTime)
              }
              if (item.updateTime) {
                item.updateTime = formatTime(item.updateTime)
              }
              item.sceneText = this.sceneTextMap[String(item.scene)] || '未知'
            })
            this.jobPushRecord = response.jobPushList
            this.pushRecordShow = true
          }
        }).catch(error => {
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    deleteJobSurvey (uid) {
      openJobApi.deleteJobSurvey(uid).then(response => {

      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    setToMenteeAccount (uid) {
      const data = {
        uid: uid,
        type: 2,
        endTime: 1798732800,
      }
      openJobApi.updateUser(data).then(response => {
        this.showToast('success', {
          duration: 1000,
          icon: 'success',
          position: 'top-center',
          fullWidth: false,
        })
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    confirmTerminateService (uid) {
      const msg = '终止服务将执行以下操作（不可撤销）：\n\n' +
        '1) 调 platform-pay 取消该用户在 Stripe 的自动续费\n' +
        '2) 立即将本地账户置为免费（type=0，endTime 设为当前时间-1）\n' +
        '3) Stripe 端走 cancel_at_period_end=true，下个周期不会再扣费\n\n' +
        '若 Stripe 调用失败将整体回滚，本地状态不变。\n\n是否确认？'
      if (window.confirm(msg)) {
        this.terminateUserService(uid)
      }
    },
    terminateUserService (uid) {
      const data = {
        uid: uid,
      }
      openJobApi.setFree(data).then(response => {
        this.showToast('success', {
          duration: 1000,
          icon: 'success',
          position: 'top-center',
          fullWidth: false,
        })
        window.location.reload()
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    formatPeriodTime: function (start, end) {
      return formatTime(start) + ' - ' + formatTime(end)
    },
    /**
     * 拉取自动代投详情；不阻塞主体 getUser 渲染。
     * 后端无 profile 时返回 hasProfile=false，前端展示提示文案。
     */
    loadAutoApply () {
      const params = this.$route.params
      if (params.uid == null) {
        return
      }
      openJobApi.getJobUserAutoApply(params.uid)
        .then(response => {
          this.autoApply = {
            hasProfile: !!response.hasProfile,
            profile: response.profile || null,
            quotaUsed: response.quotaUsed || 0,
            quotaLimit: response.quotaLimit || 0,
            userType: response.userType,
            periodStartTime: response.periodStartTime,
            periodEndTime: response.periodEndTime,
            totalSuccess: response.totalSuccess || 0,
            siteStats: response.siteStats || [],
          }
          this.autoApplyLoaded = true
        })
        .catch(error => {
          this.showToast('获取代投信息失败: ' + (error && error.msg ? error.msg : ''), {
            duration: 1500,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
    },
    confirmEmailForwardChange (enabled) {
      const desired = !!enabled
      if (desired === this.emailForwardEnabled || this.emailForwardLoading) return
      const profile = this.autoApply.profile
      if (!profile) return

      const action = desired ? '开启' : '关闭'
      const detail = desired
        ? `\n\n代投邮箱：${profile.applyEmail}\n转发至：${profile.personalEmail}`
        : `\n\n将删除代投邮箱 ${profile.applyEmail} 的 Mailcow 转发规则。`
      if (!window.confirm(`确认${action}该用户的私人邮箱转发？${detail}`)) {
        this.$forceUpdate()
        return
      }

      this.emailForwardLoading = true
      openJobApi.updateEmailForward({
        uid: this.$route.params.uid,
        enabled: desired,
      }).then(response => {
        Object.keys(response || {}).forEach(key => {
          if (key.indexOf('emailForward') === 0) {
            this.$set(this.autoApply.profile, key, response[key])
          }
        })
        this.showToast(`私人邮箱转发已${action}`, {
          duration: 1500,
          icon: 'success',
          position: 'top-center',
          fullWidth: false,
        })
      }).catch(error => {
        this.showToast(error && error.msg ? error.msg : '邮件转发同步失败', {
          duration: 2500,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        this.loadAutoApply()
      }).finally(() => {
        this.emailForwardLoading = false
      })
    },
    formatProfileValue (profile, key) {
      if (!profile) return ''
      const v = profile[key]
      if (v === null || v === undefined) return ''
      return String(v)
    },
    computeOrderStatus: function (orderStatus, renewStatus, payTimes) {
      // 试用期取消优先判：从未真实付费(payTimes=0)且已停止续费 → 立即失效
      // 注意：libabang-api 在试用期取消时仅改 jobUser.endTime/type，不改本订单的 orderStatus(=1 正式)，
      // 所以靠 payTimes=0 + renewStatus=0 区分"试用期取消"和"正式期取消不续费"
      if ((payTimes === 0 || payTimes == null) && renewStatus === 0) {
        return '试用期取消（已失效）'
      }
      let display = '未知'
      if (orderStatus === 0 && renewStatus === 0) display = '订单未支付'
      else if (orderStatus === 3 && renewStatus === 1) display = '试用期'
      else if (orderStatus === 1 && renewStatus === 1) display = '订阅中（到期自动续费）'
      else if (orderStatus === 1 && renewStatus === 0) display = '订阅中（到期不续费）'
      else if (orderStatus === 2 && renewStatus === 0) display = '订阅到期（取消订阅）'
      else if (orderStatus === 4 && renewStatus === 0) display = '续订失败'
      return display
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}

.email-forward-panel {
  border: 1px solid #e5e9f2;
  border-radius: 4px;
}
</style>
